import { createSvgIcon } from '@mui/material';
import Styled from './custom-styled-icon';

export const TickCircle = Styled(
	createSvgIcon(
		<svg
			width='16'
			height='16'
			viewBox='0 0 16 16'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M8.00016 14.6667C11.6668 14.6667 14.6668 11.6667 14.6668 8.00004C14.6668 4.33337 11.6668 1.33337 8.00016 1.33337C4.3335 1.33337 1.3335 4.33337 1.3335 8.00004C1.3335 11.6667 4.3335 14.6667 8.00016 14.6667Z'
				stroke='currentColor'
				// strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M5.1665 7.99995L7.05317 9.88661L10.8332 6.11328'
				stroke='currentColor'
				// strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>,
		'TickCircle'
	)
);

export default TickCircle;
